<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    class="FreePlan"
    title="Selected plan: Free"
    submit-name="Confirm plan"
    full-height
    @submit="submit"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <div v-if="!isTrialExpired && trialDaysLeft > 0" class="WarningTrial">
      <span
        ><span class="highlight">Note:</span> if you change to Free plan you
        will cancel your trial period ({{ trialDaysLeft }} days left)
      </span>
    </div>

    <lm-loading v-if="!landscapes" :size="32" blue />
    <template v-else>
      <template v-if="landscapes.length >= 1">
        <p class="Info">
          In a free account, you can only have one landscape and one extra
          user.<br />
          <span :class="{error}">Please select a Landscape to keep:</span>
        </p>
        <lm-landscape-selector
          ref="landscapeSelector"
          :class="{error}"
          :landscapes="landscapes"
          @landscape-selected="cleanErrors()"
        />
      </template>
      <p v-else class="Info">Confirm your plan please.</p>
    </template>
  </form-modal>
</template>

<script>
import LmLoading from '@/components/ui/LmLoading'
import {mapGetters} from 'vuex'
import {Events, Modal, Alert, AlertMessages} from '@/lib/definitions'
import {newAlert} from '@/lib/eventHub'
import FormModal from '@/components/modals/FormModal.vue'
import LmLandscapeSelector from '@/components/modals/freePlan/LmLandscapeSelector'

export default {
  name: 'ModalFreePlan',
  components: {
    LmLoading,
    FormModal,
    LmLandscapeSelector
  },
  data() {
    return {
      Events,
      modalName: Modal.FREE_PLAN,
      modalRef: null,
      landscapes: null,
      error: false
    }
  },
  computed: {
    ...mapGetters(['isTrialExpired', 'trialDaysLeft'])
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
    this.init()
  },
  methods: {
    init() {
      this.$store.dispatch('getAllSubscriptionLandscapes').then(landscapes => {
        this.landscapes = landscapes
      })
    },
    submitFromInput() {
      this.modalRef.submit()
    },
    submit() {
      this.cleanErrors()
      const landscapeSelector = this.$refs['landscapeSelector']
      const payload = {}
      if (landscapeSelector) {
        const landscape = landscapeSelector.selectedLandscape
        const user = landscapeSelector.selectedUser
        if (landscape) {
          payload.landscapeId = landscape._id
          if (user) {
            payload.userId = user._id
          }
        } else {
          this.error = true
          this.modalRef.submitFails()
          return
        }
      }
      this.$store
        .dispatch('setFreeSubscription', payload)
        .then(() => this.modalRef.submitSuccess())
        .catch(error => this.modalRef.submitFails(error))
    },
    modalClosed({fromSubmit}) {
      if (fromSubmit) {
        const msg = AlertMessages.SUBSCRIPTION_SUCCESS
        newAlert(msg, Alert.SUCCESS, true)
      }
    },
    cleanErrors() {
      this.error = false
    }
  }
}
</script>

<style scoped>
.FreePlan {
  .WarningTrial {
    margin: -24px -24px 16px;
    padding: 24px 24px;
    background-color: #f2faff;
    line-height: 1.5;
    .highlight {
      font-weight: 500;
    }
    @media (--mobile) {
      margin: -16px -16px 16px;
      padding: 16px;
    }
  }
  .Info {
    margin-bottom: 30px;
    .error {
      color: theme('colors.error');
    }
  }
  .LmLandscapeSelector.error {
    border-bottom: 1px solid theme('colors.error');
  }
}
</style>
